import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLa = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 4", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#ce1126", d: "M0 0h6v4H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#002868", d: "M0 1h6v2H0z" }), /* @__PURE__ */ React.createElement("circle", { fill: "#fff", cx: 3, cy: 2, r: 0.8 }));
const ForwardRef = forwardRef(SvgLa);
const Memo = memo(ForwardRef);
export default Memo;
